import { newsApi } from '@features/news/api/newsApi'
import { useNewsPagination } from '@features/news/composables/useNewsPagination'

/**
 * Загружает реактивный список новостей и связывает его с пагинацией.
 *
 * @returns данные списка и состояние пагинации
 */
export const useNewsList = async () => {
  const {
    countNews,
    currentPage,
    countElementsOnPage,
    countPages,
    onChangeCurrentPage,
  } = useNewsPagination()

  // useFetch отслеживает reactive query и повторяет запрос при смене страницы.
  // eslint-disable-next-line no-restricted-globals
  const params = reactive({
    page: currentPage,
    size: countElementsOnPage,
  })

  const { data: news } = await newsApi.getList(params)

  watch(
    news,
    (value) => {
      countNews.value = value?.count ?? 0
    },
    { immediate: true },
  )

  return {
    news,
    currentPage,
    countPages,
    onChangeCurrentPage,
  }
}
